/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".content[_ngcontent-%COMP%]{height:584px;overflow-y:auto}div.modal-footer[_ngcontent-%COMP%] > div.alert[_ngcontent-%COMP%]{text-align:left}\n/*# sourceMappingURL=terms-and-conditions.component.css.map*/"];
export { styles as styles };
